import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { CustomDropdownIndicator } from './components/DropdownIndicator'
import { customStyles } from './styled'
import CloseWrapper from '../close-wrapper'

function DropSelect(props) {
  const {
    disabled = false,
    clearable = false,
    searchable = true,
    optionDisabled = () => false,
    optionSelected = () => false,
    multi = false,
    loading = false,
    allowClear = true,
    onChange,
    options,
  } = props
  const [allOptions, setAllOptions] = useState([])
  const [curOptions, setCurOptions] = useState([])
  const [pageNo, setPageNo] = useState(1)
  const [pages, setPages] = useState(0)
  const pageSize = 50
  useEffect(() => {
    if (allOptions.length === 0) {
      setAllOptions(options)
    }
  }, [props.options])
  useEffect(() => {
    setPages(Math.ceil(allOptions.length / pageSize))
    setCurOptions(allOptions.slice(0, pageSize * pageNo))
  }, [allOptions, pageNo])
  const onClear = () => {
    onChange('')
  }
  return (
    <CloseWrapper allowClear={allowClear} onClear={onClear}>
      <Select
        styles={{ ...props.styles, ...customStyles }}
        isClearable={clearable}
        isDisabled={disabled}
        isLoading={loading}
        isMulti={multi}
        isOptionDisabled={optionDisabled}
        isOptionSelected={optionSelected}
        isSearchable={searchable}
        placeholder="搜索"
        components={{ DropdownIndicator: CustomDropdownIndicator }}
        onMenuScrollToBottom={() => {
          if (pageNo < pages) {
            setPageNo(pageNo + 1)
          }
        }}
        {...props}
        options={curOptions}
        onInputChange={(val) => {
          const filter = val
            ? options.filter((item) => {
                const targetVal = item?.name || item?.title
                return targetVal && targetVal.indexOf(val) > -1
              })
            : options
          setAllOptions(filter)
          setPageNo(1)
        }}
      />
    </CloseWrapper>
  )
}
// 定义参数类型
DropSelect.propTypes = {
  // eslint-disable-next-line
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  menuIsOpen: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
  inputId: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  disabled: PropTypes.bool,
  clearable: PropTypes.bool,
  searchable: PropTypes.bool,
  loading: PropTypes.bool,
  loadingMessage: PropTypes.func,
  optionDisabled: PropTypes.func,
  optionSelected: PropTypes.func,
  defaultValue: PropTypes.oneOfType([PropTypes.arrayOf(), PropTypes.shape()]),
  defaultMenuIsOpen: PropTypes.bool,
  multi: PropTypes.bool,
  minMenuHeight: PropTypes.number,
  maxMenuHeight: PropTypes.number,
  menuPlacement: PropTypes.string,
  menuShouldBlockScroll: PropTypes.bool,
  menuShouldScrollIntoView: PropTypes.bool,
  noOptionsMessage: PropTypes.func,
  placeholder: PropTypes.string,
  autoFocus: PropTypes.bool,
  backspaceRemovesValue: PropTypes.bool,
  blurInputOnSelect: PropTypes.bool,
  captureMenuScroll: PropTypes.bool,
  closeMenuOnSelect: PropTypes.bool,
  closeMenuOnScroll: PropTypes.bool,
  filterOption: PropTypes.func,
  formatGroupLabel: PropTypes.func,
  formatOptionLabel: PropTypes.func,
  hideSelectedOptions: PropTypes.bool,
  pageSize: PropTypes.number,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
}

// 定义默认参数
DropSelect.defaultProps = {
  //   options: [],
  //   // menuIsOpen: true,
  //   id: undefined,
  //   name: undefined,
  //   inputId: undefined,
  //   className: undefined,
  //   width: '100%',
  //   styles: {},
  //   disabled: false,
  //   clearable: false,
  //   searchable: true,
  //   loading: false,
  //   loadingMessage: () => {},
  //   optionDisabled: () => {},
  //   optionSelected: () => {},
  //   defaultValue: undefined,
  //   defaultMenuIsOpen: false,
  //   multi: false,
  //   minMenuHeight: undefined,
  //   maxMenuHeight: undefined,
  //   menuPlacement: 'auto',
  //   menuShouldBlockScroll: false,
  //   menuShouldScrollIntoView: true,
  //   noOptionsMessage: 'no Options',
  //   placeholder: '',
  //   autoFocus: false,
  //   backspaceRemovesValue: true,
  //   blurInputOnSelect: false,
  //   captureMenuScroll: false,
  //   closeMenuOnSelect: true,
  //   closeMenuOnScroll: false,
  //   filterOption: () => {},
  //   formatGroupLabel: () => {},
  //   formatOptionLabel: () => {},
  //   hideSelectedOptions: false,
  //   pageSize: undefined,
  //   onChange: () => {},
  //   onFocus: () => {},
  //   onBlur: () => {},
  //   onMenuOpen: () => {},
  //   onMenuClose: () => {},
  //   onKeyDown: () => {},
  //   onMenuScrollToTop: () => {},
  //   onMenuScrollToBottom: () => {},
}

export default DropSelect
